import styled from "styled-components";

export default styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 50;

    .button {
        margin: 0;
    }

    .modalInner {
        display: flex;
        flex-direction: column;
        width: 95%;
        max-width: 1800px;
        height: 90vh;
        background-color: ${(props) => props.theme.modalInnerBackground};
        box-shadow: ${(props) => props.theme.modalBoxShadow};
        border-radius: 5px;
        overflow: hidden;

        .header {
            display: flex;
            flex-direction: column;
            padding: 10px 20px;
            color: ${(props) => props.theme.pageTitleText};

            .topRow {
                display: flex;
                justify-content: space-between;

                .title {
                    display: flex;
                    align-items: center;
                    gap: 12px;

                    h1 {
                        margin: 0;
                    }
                }

                .headerActions {
                    display: flex;
                    gap: 10px;

                    .button {
                        margin-top: 5px;
                    }
                }
            }
        }

        > div:has(.tabsBar) {
            flex: 1;
            min-height: 0;
            overflow: hidden;

            .tabsBar {
                flex-shrink: 0;
            }

            .tabsContent {
                display: flex;
                flex-direction: column;
                flex: 1;
                min-height: 0;
                overflow: auto;
                padding: 20px;
            }
        }

        .content {
            padding: 20px;
            display: flex;
            flex-direction: column;
            gap: 20px;
            overflow-y: auto;
            flex: 1;

            &.noGap {
                gap: 0;
            }

            .stepOneContainer {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                flex: 1;
                gap: 30px;

                .checkboxField {
                    display: flex;
                    align-items: center;
                    gap: 8px;

                    label {
                        font-size: 12px;
                        font-weight: 600;
                        letter-spacing: 1px;
                        color: ${(props) => props.theme.textSecondary};
                        margin-bottom: 0;
                        cursor: pointer;
                        user-select: none;
                    }

                    .MuiCheckbox-root {
                        padding: 8px;
                    }

                    &.labelFirst {
                        label {
                            order: 1;
                            margin-top: 4px;
                        }

                        .MuiCheckbox-root {
                            order: 2;
                        }
                    }
                }

                .stepOneDescription {
                    font-size: 16px;
                    color: ${(props) => props.theme.textPrimary};
                    line-height: 1.6;
                    text-align: center;
                    max-width: 500px;
                    margin: 0;
                }

                .tickerField {
                    display: flex;
                    flex-direction: column;
                    width: 350px;

                    label {
                        font-size: 12px;
                        font-weight: 600;
                        letter-spacing: 1px;
                        color: ${(props) => props.theme.textSecondary};
                        margin-bottom: 8px;
                    }

                    > div {
                        margin-bottom: 0;
                    }
                }
            }
        }

        .actions {
            display: flex;
            justify-content: flex-end;
            gap: 10px;
            padding: 20px;
            border-top: 1px solid ${(props) => props.theme.border};
            background-color: ${(props) => props.theme.modalInnerBackground};
            border-radius: 0 0 5px 5px;
        }
    }
    .loadingContainer,
    .errorContainer {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 200px;
    }
`;
